/*eslint-disable react/no-set-state*/
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory, Link } from 'react-router';
import ReactTooltip from 'react-tooltip';
import { Glyphicon } from 'react-bootstrap';
import { searchForFormById } from '../../../selectors/searchForForm';
import { createInjurySummaryObject } from '../../injurySummary/injurySummaryModel';
import { createSubmitEstablishmentObject } from '../EstablishmentSubmissionObject';
import EstablishmentHeader from './EstablishmentHeader';
import EstablishmentCheckList from './EstablishmentCheckList';
import InjurySummaryTable from '../../injurySummary/InjurySummaryTable/InjurySummaryTable';
import EmptySummaryText from './EmptySummaryText';
import EstablishmentSubmitModal from '../EstablishmentSubmitModal';
import EstablishmentRemovalForm from '../EstablishmentRemovalForm';
import Button from '../../common/Button';
import SelectInput from '../../common/SelectInput';
import { ITAAlert } from '../../common/ITAAlert';
import * as FormName from '../../../constants/formNameConstants';
import * as pathConstants from '../../../constants/pathConstants';
import * as injurySummaryActions from '../../../actions/injurySummaryActions';
import * as establishmentActions from '../../../actions/establishmentActions';
import * as EstablishmentConstants from '../../../constants/EstablishmentStatusEnumeration';
import '../../../styles/establishment/establishmentSingleView.css';
import EstablishmentUsers from './EstablishmentUsers';
import * as establishmentUserActions from '../../../actions/establishmentUserActions';
import {createApiPathWithQueryStrings} from '../../../api/fetch/fetchServices';
import * as apiConstants from '../../../constants/apiConstants';
import ConfirmationModal from '../ConfirmationModal';
import * as PathConstants from '../../../constants/pathConstants';
import {ESTABLISHMENT_STATE_RULES_ENUMERATION as establishmentEnumeration}  from '../../../constants/EstablishmentStatusEnumeration';

class EstablishmentPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      establishment: this.props.establishment,
      injurySummary: {},
      selectedSummary: {},
      formId: "",
      resubmissionReason: "",
      showModal: false,
      showRemovalForm: false,
      submitAll: false,
      hideInactive: true,
      isActive: true,
      message: null,
      errorMessage: null,
      selectedYear: this.props.filingYear,
      required_301: EstablishmentConstants.ESTABLISHMENT_NOT_REQUIRED_TO_SUBMIT_301,
      size_reclassification_required: false,
      showConfirmationModal: false,
      confirmationModalText: '',
      state_plan:  false
    };
    this.createInjurySummary = this.createInjurySummary.bind(this);
    this.editInjurySummary = this.editInjurySummary.bind(this);
    this.restoreEstablishment = this.restoreEstablishment.bind(this);
    this.editEstablishment = this.editEstablishment.bind(this);
    this.redirect = this.redirect.bind(this);
    this.submitEstablishment = this.submitEstablishment.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.enteringResubmissionReason = this.enteringResubmissionReason.bind(this);
    this.removeEstablishment = this.removeEstablishment.bind(this);
    this.showRemovePage = this.showRemovePage.bind(this);
    this.hideRemovePage = this.hideRemovePage.bind(this);
    this.createCaseData = this.createCaseData.bind(this);
    sessionStorage.setItem('onLogin', '2');
    this.establishmentUserSuccess = this.establishmentUserSuccess.bind(this);
    this.establishmentUserError = this.establishmentUserError.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleConfirmModal = this.handleConfirmModal.bind(this);
    this.goBackToHomePage = this.goBackToHomePage.bind(this);
  }

  componentDidMount() {
    if (this.props.user && this.props.establishment) {
      if (!this.props.establishment) {
        this.props.injSumActions.loadAllInjurySummaryData(parseInt(this.props.params.id));
        this.props.establishmentUsersActions.loadAllEstablishmentUsers(parseInt(this.props.params.id));
      } else {
        this.props.injSumActions.loadAllInjurySummaryData(this.props.establishment.id);
        this.props.establishmentUsersActions.loadAllEstablishmentUsers(this.props.establishment.id);
      }
      this.props.submissionLinks.forEach(link => {
        this.props.establishmentActions
          .loadSubmissionData(link);
      });

      // Get the submission id for the establishment (@copilot).
      const submissionId = getSubmissionId(this.props.submissions, this.props.establishment.id, this.state.formId, this.state.selectedYear);
      this.setState({ submissionId });  
      // Check if 301 is required for this establihsment.
      this.check300and301Requirement(
        this.props.establishment.naics.naics_code,
        this.props.establishment.size,
        this.props.establishment.address.state,
        this.props.establishment.establishment_type
      );
    }
    else {
      // No data so redirect user to home page.
      // Manual detection of page refresh is not supported in modern browser. This a workaround
      // To redirect users to home page on page refresh if unable to load data.
      this.goBackToHomePage();
    }
  }

  goBackToHomePage() {
    console.log('Return user to home page');
    this.redirect(PathConstants.pathToHome);
  }

  check300and301Requirement(naics_code, size, state, establishment_type) {
    // If the establishment is from exluded state set required_301 to 3.
    const excludedStatesData = window.getExcludedStatesData();
    let managed_by_state_plan = false;
    if (excludedStatesData['fully_excluded_states'].includes(state.toUpperCase())) {
      this.setState({ state_plan: true });
      managed_by_state_plan = true;
    }
    else if (excludedStatesData['partially_excluded_states'].includes(state.toUpperCase()) &&
      (establishment_type == establishmentEnumeration.STATE_GOVERNMENT || establishment_type == establishmentEnumeration.LOCAL_GOVERNMENT)) {
      this.setState({ state_plan: true });
      managed_by_state_plan = true;
    }
    // If the establishment is part of excluded state ignore the following block of code.
    if (managed_by_state_plan) {
      // If the establishment is a self identified state or local entity or is from a state plan states show all the forms.
      this.setState({ required_301: EstablishmentConstants.ESTABLISHMENT_REQUIRED_TO_SUBMIT_301});
    }
    else {
      if (size == 1 || size == 21) {
        // If establishment size is 1 set the 301 requirment to 0
        this.setState({ required_301: EstablishmentConstants.ESTABLISHMENT_NOT_REQUIRED_TO_SUBMIT_301});
      }
      else {
        let queryParams = {
          naics: naics_code,
        };
        let eligiblityCheckPath =
          createApiPathWithQueryStrings(apiConstants.caseDataFormRequired, queryParams);
        fetch(eligiblityCheckPath)
          .then(response => response.json())
          .then(data => {
            const required_301 = data['300and301_required_301'];
            // If column I is true and establishment size is 20-249, requires reclassification.
            if (required_301 == true && size == 2) {
              this.setState({size_reclassification_required: true});
            }
            if (required_301 == true) {
              this.setState({ required_301: EstablishmentConstants.ESTABLISHMENT_REQUIRED_TO_SUBMIT_301});
            }
            else {
              this.setState({ required_301: EstablishmentConstants.ESTABLISHMENT_NOT_REQUIRED_TO_SUBMIT_301});
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
            this.setState({ required_301: EstablishmentConstants.ESTABLISHMENT_NOT_REQUIRED_TO_SUBMIT_301});
          });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if the relevant props have changed
    if (this.props.establishment !== prevProps.establishment ||
        this.props.injurySummary !== prevProps.injurySummary ||
        this.props.formId !== prevProps.formId ||
        this.props.submissions !== prevProps.submissions) {
      // Update the state based on the new props
      let submissionId = getSubmissionId(
        this.props.submissions,
        this.props.establishment.id,
        this.props.formId,
        this.state.selectedYear
      );
  
      this.setState({
        injurySummary: this.props.injurySummary,
        formId: this.props.formId,
        submissionId: submissionId,
      });
  
      // Handle success messages
      if (this.props.successMsg === "Successful" && !this.state.message) {
        let message = this.props.emptyEstablishment
          ? (
            <div className="first-line">
              You have successfully created an Establishment
            </div>
          ) : (
            <div className="first-line">
              You have successfully edited an Establishment
            </div>
          );
        this.setState({ message: message });
      } else if (this.props.successMsg === "InjurySummary" && !this.state.message) {
        let submissionDate = new Date();
        let message = (
          <div>
            <div className="first-line">
              On {submissionDate.toLocaleDateString()} at {submissionDate.toLocaleTimeString()}, you have successfully submitted the establishment to OSHA.
            </div>
            An email confirmation will be sent shortly.
          </div>
        );
        this.setState({ message: message });
      }
  
      // Redirect if establishment not found
      if (this.props.establishmentNotFound && this.props.establishments.length > 0) {
        this.redirect(pathConstants.pathToAccessDenied);
      }
    }
  }
  

  createInjurySummary(event) {
    event.preventDefault();
    let path = `${pathConstants.pathToEstablishmentsDashboardPage}/`
      + this.props.establishmentId
      + pathConstants.pathToInjurySummaryFormPageAdd;
    this.redirect(path);
  }

  createCaseData(event) {
    event.preventDefault();
    let path = `${pathConstants.pathToEstablishmentsDashboardPage}/`
      + this.props.establishmentId
      + pathConstants.pathToCaseDataDashboardPage;
    this.redirect(path);
  }

  editInjurySummary(event) {
    event.preventDefault();
    let path = `${pathConstants.pathToEstablishmentsDashboardPage}/`
      + this.props.establishmentId
      + pathConstants.pathToInjurySummaryFormPageEdit
      + `/${this.state.formId}`;
    this.redirect(path);
  }

  openModal(event) {
    event.preventDefault();
    if (
      this.state.required_301 &&
      !this.state.state_plan && // must not be part of state plan
      this.state.injurySummary.totalSubmittedCases != this.state.injurySummary.totalExpectedCases && //300a & 300/301 case count mismatched
      this.state.size_reclassification_required != true &&//est size not 20-249
      this.state.establishment.size != 21 // do not show to establishments with size 20-99
    ) {
      const confirmationText = (
        <div>
          {this.state.state_plan &&
            <p><strong>Your establishment is covered by a State Plan. Please contact your
              <a style={{'color':'#039', 'text-decoration':'underline', 'margin':'0px 4px'}} target="_blank" href="https://www.osha.gov/stateplans">State Plan</a>
              for information about your reporting requirements.</strong></p>
          }
          <p><strong>Total Submitted Cases is not equal to Total Expected Cases. Do you want to proceed?</strong></p>
          <table border="1" className="submitConfirmTable">
            <thead>
              <tr>
                <th></th>
                <th>Total Expected Cases</th>
                <th>Total Submitted Cases</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Cases with deaths</td>
                <td>{this.state.injurySummary.totalDeaths === 0 || this.state.injurySummary.totalDeaths === "" ? "0" : this.state.injurySummary.totalDeaths}</td>
                <td>{this.state.injurySummary.totalDeathCasesCount === 0 || this.state.injurySummary.totalDeathCasesCount === "" ? "0" : this.state.injurySummary.totalDeathCasesCount}</td>
              </tr>
              <tr>
                <td>Cases with days away from work</td>
                <td>{this.state.injurySummary.totalDafwCases === 0 || this.state.injurySummary.totalDafwCases === "" ? "0" : this.state.injurySummary.totalDafwCases}</td>
                <td>{this.state.injurySummary.totalDafwCasesCount === 0 || this.state.injurySummary.totalDafwCasesCount === "" ? "0" : this.state.injurySummary.totalDafwCasesCount}</td>
              </tr>
              <tr>
                <td>Cases with days on job transfer</td>
                <td>{this.state.injurySummary.totalDjtrCases === 0 || this.state.injurySummary.totalDjtrCases === "" ? "0" : this.state.injurySummary.totalDjtrCases}</td>
                <td>{this.state.injurySummary.totalDjtrCasesCount === 0 || this.state.injurySummary.totalDjtrCasesCount === "" ? "0" : this.state.injurySummary.totalDjtrCasesCount}</td>
              </tr>
              <tr>
                <td>Other cases</td>
                <td>{this.state.injurySummary.totalOtherCases === 0 || this.state.injurySummary.totalOtherCases === "" ? "0" : this.state.injurySummary.totalOtherCases}</td>
                <td>{this.state.injurySummary.totalOtherCasesCount === 0 || this.state.injurySummary.totalOtherCasesCount === "" ? "0" : this.state.injurySummary.totalOtherCasesCount}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
      // Show the case number confirmation modal
      this.setState({ showConfirmationModal: true });
      this.setState({confirmationModalText: confirmationText});
    } else {
      // Open the modal if the condition is not met
      this.setState({ showModal: true });
    }
  }


  closeModal(event) {
    if (event) {
      event.preventDefault();
    }
    this.setState({
      showModal: false,
      isActive: true,
      resubmissionReason: ""
    });
  }

  removeEstablishment(event) {
    event.preventDefault();
    let path =
      `${pathConstants.pathToEstablishmentsDashboardPage}`;
    let establishment = this.props.establishment;
    this.props.establishmentActions
      .removeEstablishment(establishment, establishment.id)
      .then(() => {
        this.setState({ message: 'Establishment was successfully removed' });
      }).catch(error => {
        throw (error.message);
      });
    this.hideRemovePage();
    this.redirect(path);
  }

  showRemovePage(event) {
    event.preventDefault();
    this.setState({ showRemovalForm: true });
  }

  hideRemovePage() {
    this.setState({ showRemovalForm: false });
  }

  submitEstablishment(event) {
    event.preventDefault();
    const establishment = this.props.establishment;
    const resubmissionReason = this.state.resubmissionReason;
    const submission = createSubmitEstablishmentObject(establishment, this.state.selectedYear, resubmissionReason);
    this.closeModal();
    this.props.establishmentActions
      .submitEstablishments(submission).then(() => {
        let updatedEstablishment = this.state.establishment;
        updatedEstablishment.submission_status = 3;
        updatedEstablishment.combined_submission_status = 1;
        let date = new Date();
        const message = (
          <div>
            <div className="first-line">
              On {date.toLocaleDateString()} at {date.toLocaleTimeString()}, you successfully submitted this establishment to OSHA.
            </div>
            <br />
            An email confirmation will be sent shortly.
          </div>);
        this.setState({
          establishment: updatedEstablishment,
          message: message
        }, function () {
          this.props.injSumActions.loadAllInjurySummaryData(this.props.establishment.id);
        });
      }).catch(error => {
        this.closeModal();
        throw (error);
      });
  }

  handleClick() {
    let isActive = this.state.isActive;
    if (!isActive) {
      isActive = true;
    } else {
      isActive = false;
    }
    this.setState({ isActive: isActive });
  }

  enteringResubmissionReason(event) {
    event.preventDefault;
    this.setState({ resubmissionReason: event.target.value });
  }

  restoreEstablishment(event) {
    event.preventDefault();
    let path =
      `${pathConstants.pathToEstablishmentsDashboardPage}`;
    this.props.establishmentActions.restoreEstablishment(
      this.props.establishment,
      this.props.establishmentId)
      .then(() => {
        this.redirect(path);
      }).catch(error => {
        throw (error);
      });
  }

  editEstablishment(event) {
    event.preventDefault();
    let path =
      `${pathConstants.pathToEstablishmentsDashboardPage}/`
      + this.props.establishmentId
      + pathConstants.pathToEditEstablishmentPage;
    this.redirect(path);
  }

  redirect(path) {
    browserHistory.push(path);
  }

  redirectWithRefresh(path) {
    browserHistory.push(path);
    window.location.reload();
  }

  removalRedirect(event) {
    event.preventDefault();
  }

  handleChange(event) {
    let year = event.target.value;
    //since filingYear is default option it has no value.
    if (year == "") {
      year = this.props.filingYear;
    } else if (year.indexOf('"') < 0) {
      year = parseInt(year);
    }
    let selectedSummary = getInjurySummaryByFilingYear(
      this.props.injurySummaryList, year);

    let returnFormId = "";
    let updatedEstablishment = this.state.establishment;

    if (selectedSummary) {
      updatedEstablishment.submission_status = selectedSummary.submission_status;

      selectedSummary = createInjurySummaryObject(selectedSummary);
      returnFormId = selectedSummary.id;
    } else {
      selectedSummary = {};
      selectedSummary.annualAverageEmployees = "";
      selectedSummary.totalHoursWorked = "";
      updatedEstablishment.submission_status = 1;
    }

    let submissionId = "";
    if (returnFormId) {
      submissionId = getSubmissionId(this.props.submissions,
        updatedEstablishment.id, returnFormId, year);
    }

    this.setState({
      establishment: updatedEstablishment,
      injurySummary: selectedSummary,
      submissionId: submissionId,
      formId: returnFormId,
      selectedYear: year,
    }, function () {
      this.forceUpdate();
    });
  }

  establishmentUserSuccess(successMessage) {
    let msg = (<div>
    <div className="first-line">{successMessage}</div>
    <div className="first-line">Note: It may take 15 minutes for changes to reflect on the Establishment List and Establishment Details screens.</div>
    </div>);
    this.setState({ message: msg, errorMessage: null });
  }

  establishmentUserError(errorMessage){
    let msg = (<div className="first-line">{errorMessage}</div>);
    this.setState({ errorMessage: msg, message: null });
  }
  handleConfirmModal(event) {
    event.preventDefault();
    this.setState({ showConfirmationModal: false }, () => {
      // If the user confirms, proceed to open the main modal
      this.setState({ showModal: true });
    });
  }
  handleCloseModal(event) {
    event.preventDefault();
    // Close both the confirmation modal
    this.setState({ showConfirmationModal: false});
  }

  render() {
    return (
      <div>
        {this.props.establishment &&
          <div id="establishment-single-page">
            {this.state.message && this.state.message != "" && this.state.message != null &&
              <ITAAlert style="success"
                message={this.state.message} />
            }
            {this.state.errorMessage && this.state.errorMessage != "" && this.state.errorMessage != null &&
              <ITAAlert style="danger"
                message={this.state.errorMessage} />
            }
            <div className="row">
              {this.props.establishment.establishment_name &&
                <EstablishmentHeader
                  establishment={this.state.establishment}
                  restoreEstablishment={this.restoreEstablishment}
                  showRemovePage={this.showRemovePage}
                  editEstablishment={this.editEstablishment}
                  requireSizeReclassification={this.state.size_reclassification_required} />}
              <div className="col-xs-12 col-sm-3 establishment-checklist-container">
                <EstablishmentCheckList
                  establishment={this.state.establishment}
                  required_301={this.state.required_301}
                  has_expected_301={this.state.injurySummary.totalSubmittedCases >= this.state.injurySummary.totalExpectedCases}
                />
              </div>
            </div>
            <div className="col-xs-12 border-container injury-summary-container">
              <EstablishmentUsers establishmentId={this.props.establishmentId} establishmentUsers={this.props.estUsers}
                validateEstUser={this.props.establishmentUsersActions.validateEstablishmentUser} user={this.props.user}
                saveEstUser={this.props.establishmentUsersActions.saveEstablishmentUser} saveUserSuccess={this.establishmentUserSuccess}
                saveUserError={this.establishmentUserError}/>
            </div>
            <div className="col-xs-12 border-container injury-summary-container">
              <div className="row " id="injury-summary-header-row">
                <div className="col-xs-12 injury-summary-title-div">
                  <h2 id="injury-summary-table-title">
                    Summary for Filing Year {this.state.selectedYear}
                  </h2>
                  <div className="establishment-year-select">
                    <SelectInput
                      name="selected_year"
                      options={this.props.yearOptions}
                      onChange={this.handleChange}
                      value={this.state.selectedYear.toString()}
                      defaultOption={this.props.filingYear.toString()}
                    />
                  </div>
                  {this.state.submissionId &&
                    <Link to={
                      `${pathConstants.pathToEstablishmentsDashboardPage}/${this.props.establishmentId}` +
                      `${pathConstants.pathToSubmissionPage}/${this.state.submissionId}`}>
                      View Submission
                    </Link>
                  }
                </div>
                {!this.props.formId &&
                  <div className="col-xs-12 mobile"><EmptySummaryText /></div>
                }
                <div className="col-sm-3 pull-right"
                  id="injury-summary-button-container">
                  {this.props.formId
                    ? (
                      <div>
                      <Button
                      onClick={this.editInjurySummary}
                      value="Edit 300A Data"
                      disabled={this.props.establishment.establishment_status == 2 ||
                        this.state.selectedYear != this.props.filingYear}
                      className="outlined-button summary-button" />
                      {this.state.required_301 === EstablishmentConstants.ESTABLISHMENT_REQUIRED_TO_SUBMIT_301 ?
                      <div className={ this.state.injurySummary.totalExpectedCases === 0 ? 'toolTip' : ''}>
                      <Button
                      onClick={this.createCaseData}
                      value="Add or Edit 300/301 Data"
                      className="case-data-button summary-button"
                      disabled={ this.state.injurySummary.totalExpectedCases === 0 }/>
                      <span className={ this.state.injurySummary.totalExpectedCases === 0 ? 'toolTipText' : ''}></span>
                      </div>
                      : <div></div>}
                      {this.state.state_plan &&
                        <div className="state-rule-info">
                          <p><a style={{'margin-right':'5px'}} target="_blank" href="https://www.osha.gov/stateplans">State-specific</a> 300/301 submission rules apply.
                            <Glyphicon glyph="info-sign" className="span-tooltip" data-tip data-for="stateplan-rule" />
                          </p>
                          <ReactTooltip id="stateplan-rule" place="left" type="dark" effect="float">
                          Your establishment is covered by a State Plan. Please contact your <br /> State Plan for information about your reporting requirements
                          </ReactTooltip>
                        </div>
                      }
                      </div>
                    ) :
                    ( <Button
                      disabled={this.props.establishment.establishment_status == 2 ||
                        this.state.selectedYear != this.props.filingYear ||
                        this.state.size_reclassification_required == true}
                      onClick={this.createInjurySummary}
                      value="Add 300A Data"
                      className="summary-button"
                    />
                    )}
                    {this.state.size_reclassification_required &&
                    <div className="size-reclassification-info">
                        <span className="tooltip-container" onClick={this.editEstablishment}>
                          <Glyphicon glyph="warning-sign" className="establishment-size-alert"
                          data-tip data-for={"establishment-id"}/>
                          <ReactTooltip id={"establishment-id"} place="right"
                          type="dark" effect="float">
                          Edit establishment details to update the size.
                          </ReactTooltip>
                        </span>
                        <p>Establishment size reclassification required.</p>
                      </div>
                    }
                  {this.state.required_301 === EstablishmentConstants.ESTABLISHMENT_REQUIRED_TO_SUBMIT_301 ?
                  <Button
                    onClick={this.openModal}
                    value="Submit Data"
                    disabled={this.props.submitDisabled ||
                      !this.state.formId ||
                      this.props.establishment.combined_submission_status == 1 ||
                      this.state.injurySummary.combined_submission_status == 1 ||
                      this.state.selectedYear != this.props.filingYear}
                    className="submit-button"/>
                    : null
                   }
                </div>
                <div className="col-sm-5" id="employee-information">
                  <h3>Employee Information</h3>
                  <div id="annual-average-employees">
                    <b>Annual average number of employees:</b> {this.state.injurySummary.annualAverageEmployees}
                  </div>
                  <div id="total-hours-worked">
                    <b>Total hours worked by all employees last year:</b> {this.state.injurySummary.totalHoursWorked}
                  </div>
                  <div id="total-cases">
                    {this.state.required_301 === EstablishmentConstants.ESTABLISHMENT_REQUIRED_TO_SUBMIT_301 && (
                      <div>
                        <b>Total Cases Submitted:</b> {this.state.injurySummary.totalSubmittedCases} out of {this.state.injurySummary.totalExpectedCases}
                      </div>
                    )}
                    {/* Nothing is rendered when required_301 is false */}
                  </div>
                </div>
              </div>
              {!this.state.formId
                ? <div className="non-mobile"><EmptySummaryText /></div>
                : <InjurySummaryTable
                  injurySummary={this.state.injurySummary}
                  form={this.props.questionForm}
                  showEmployeeInfo={false}
                />
              }
            </div>
            <div className="col-xs-12 border-container injury-summary-container">
              <h2 className="col-xs-12 injury-and-illness-container-title" id="injury-and-illness-container-title">
                Illness & Injury Rates
              </h2>
              <div id="tcr">
                <b>Total Case Incidence Rate (TCR):</b> {this.state.injurySummary.tcr}
                <Glyphicon glyph="info-sign" className="span-tooltip"
                  data-tip data-for={"tcr-id"} />
                <ReactTooltip id={"tcr-id"} place="right"
                  type="dark" effect="float" >
                  The incidence rate for all recordable cases of injuries and illnesses is computed using the following formula:
                  <br />
                  <br />
                  Total number of injuries and illnesses X 200,000 ÷ Number of hours worked by all employees = Total recordable case rate
                </ReactTooltip>
              </div>
              <div id="dart">
                <b>Days Away Restrictions and Transfers (DART):</b> {this.state.injurySummary.dart}
                <Glyphicon glyph="info-sign" className="span-tooltip"
                  data-tip data-for={"dart-id"} />
                <ReactTooltip id={"dart-id"} place="right"
                  type="dark" effect="float" >
                  The incidence rate for recordable cases involving days away from work, days of restricted work activity or job transfer (DART) can be computed using the following formula:
                  <br />
                  <br />
                  (Number of entries in column H + Number of entries in column I) X 200,000 ÷ Number of hours worked by all employees = DART incidence rate
                </ReactTooltip>
              </div>
            </div>
            <EstablishmentRemovalForm
              onRemove={this.removeEstablishment}
              onChange={this.removalRedirect}
              hideRemovePage={this.hideRemovePage}
              showRemovePage={this.showRemovePage}
              showModal={this.state.showRemovalForm}
              establishment={this.props.establishment}
              removalForm={this.props.removalForm}
            />
            <EstablishmentSubmitModal
              showModal={this.state.showModal}
              onHide={this.closeModal}
              submitForm={this.props.submitForm}
              isResubmit={this.props.isResubmission}
              isActive={this.state.isActive}
              resubmissionReason={this.state.resubmissionReason}
              onSubmit={this.submitEstablishment}
              onClick={this.handleClick}
              onChange={this.enteringResubmissionReason}
              numberOfEstablishments={1} />
            <ConfirmationModal
              modalShown={this.state.showConfirmationModal}
              onHide={this.handleCloseModal}
              onConfirm={this.handleConfirmModal}
              confirmTitle="Confirm submission"
              confirmText={this.state.confirmationModalText}
              confirmButtonText="Yes"
              cancelButtonText="No"
            />
          </div>
        }
      </div>
    );
  }
}

EstablishmentPage.propTypes = {
  establishment: PropTypes.object,
  establishments: PropTypes.array,
  establishmentNotFound: PropTypes.bool,
  establishmentId: PropTypes.string.isRequired,
  successMsg: PropTypes.string,
  emptyEstablishment: PropTypes.bool,
  newSummary: PropTypes.bool.isRequired,
  injurySummary: PropTypes.object.isRequired,
  injurySummaryLinks: PropTypes.array.isRequired,
  injurySummaryList: PropTypes.array,
  injSumActions: PropTypes.object.isRequired,
  submissions: PropTypes.array,
  submissionLinks: PropTypes.array.isRequired,
  establishmentActions: PropTypes.object.isRequired,
  questionForm: PropTypes.object.isRequired,
  removalForm: PropTypes.object.isRequired,
  submitForm: PropTypes.object.isRequired,
  forbidden: PropTypes.bool.isRequired,
  user: PropTypes.object,
  formId: PropTypes.number,
  submissionId: PropTypes.number,
  submitDisabled: PropTypes.bool,
  isResubmission: PropTypes.bool,
  yearOptions: PropTypes.array,
  filingYear: PropTypes.number,
  params: PropTypes.object,
  required_301: PropTypes.number,
  size_reclassification_required: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  let estUsers = state.establishmentUsers;
  const establishmentId = ownProps.params.id;
  let establishmentNotFound = false;
  let establishments = state.establishments;
  let successMsg = "";
  let emptyEstablishment = false;
  let newSummary = false;
  if (ownProps.location.state) {
    successMsg = ownProps.location.state.successMsg;
    emptyEstablishment = ownProps.location.state.emptyEstablishment;
    newSummary = ownProps.location.state.newSummary;
  }

  let isResubmission = false;
  let questionForm = {};
  let submitForm = {};
  let removalForm = {};
  let user = state.user.slice(-1)[0] || {};
  let forbidden = false;
  let submitDisabled = false;
  if (state.forms.length > 0) {
    questionForm =
      searchForFormById(state.forms, FormName.itaInjurySummaryFormId);
    submitForm =
      searchForFormById(state.forms, FormName.itaSubmitModalId);
    removalForm =
      searchForFormById(state.forms, FormName.removeEstablishmentFormId);
  }

  let establishment = null;

  if (establishmentId && state.establishments.length > 0) {
    establishment = getEstablishmentById(state.establishments, establishmentId);
  }
  if (!establishment && establishmentId) {
    establishmentNotFound = true;
  }


  let injurySummaryLinks = [];

  if (establishment && establishment.links && establishment.links.form300a_links) {
    establishment.links.form300a_links.forEach(link => {
      injurySummaryLinks.push(link);
    });
  }

  let submissionLinks = [];
  if (establishment && establishment.links &&
    establishment.links.submission_links) {
    establishment.links.submission_links.forEach(link => {
      submissionLinks.push(link);
    });
  }

  let yearOptions = [];
  let year = new Date().getFullYear();
  let filingYear = year - 1;

  let injurySummary = {};
  let injurySummaryList = [];

  if (state.injurySummaries && state.injurySummaries.length > 0) {
    //replace filingYear with dropdown for year selection
    injurySummary = getInjurySummaryByFilingYear(state.injurySummaries,
      filingYear) || {};
    if (injurySummary) {
      injurySummary = createInjurySummaryObject(injurySummary);
    }

    state.injurySummaries.forEach(summary => {
      injurySummaryList.push(summary);
    });
  }

  injurySummaryList.forEach(summary => {
    let yearOpt = summary.year_filing_for;
    //adding filingYear makes it appear twice in array because it is
    //default value. don't add filingYear
    if (yearOpt != filingYear) {
      let entry = {};
      entry.value = yearOpt;
      entry.key = yearOpt;
      yearOptions.push(entry);
    }
  });

  yearOptions.sort(function (a, b) {
    return parseInt(b.key) - parseInt(a.key);
  });

  let formId = null;
  if (injurySummary.id) {
    formId = injurySummary.id;
  }

  let submissions = [];
  let submissionId = null;
  if (establishment &&
    establishment.submission_status === 3) {
    if (state.submissions && state.submissions.length > 0) {
      submissions = state.submissions;
      submissionId = getSubmissionId(state.submissions, establishment.id, formId, filingYear);
    }
  }

  if (establishment && establishment.combined_submission_status == 1) {
    submitDisabled = true;
  }

  if (establishment && establishment.COMBINED_SUBMISSION_COMPLETED ==EstablishmentConstants.COMBINED_SUBMISSION_COMPLETED && establishment.years_submitted
    && checkIfResubmission(establishment, filingYear) >= 0) {
    isResubmission = true;
  }

  return {
    establishment,
    establishmentNotFound,
    establishments,
    establishmentId,
    injurySummary,
    injurySummaryList,
    injurySummaryLinks,
    submissions,
    submissionId,
    submissionLinks,
    emptyEstablishment,
    newSummary,
    formId,
    questionForm,
    removalForm,
    successMsg,
    forbidden,
    submitDisabled,
    submitForm,
    isResubmission,
    filingYear,
    user,
    yearOptions,
    estUsers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    injSumActions: bindActionCreators(injurySummaryActions, dispatch),
    establishmentActions: bindActionCreators(establishmentActions, dispatch),
    establishmentUsersActions: bindActionCreators(establishmentUserActions, dispatch)
  };
}

function getEstablishmentById(establishments, id) {
  const establishment =
    establishments.filter(establishment => establishment.id == id);
  if (establishment) {
    return establishment[0];
  }
  return null;
}

function getInjurySummaryByFilingYear(injurySummaries, filingYear) {
  const injurySummary = injurySummaries.filter(injurySummary => {
    if (injurySummary.year_filing_for == filingYear) {
      return injurySummary;
    }
  });

  if (injurySummary) {
    return injurySummary[0];
  }
  return null;
}

function getSubmissionId(submissions, establishmentId, injurySummaryId, filingYear) {
  const submission = submissions.filter(submission => {
    if (submission.establishment.id == establishmentId
      && submission.form300a.id == injurySummaryId
      && submission.form300a.year_filing_for == filingYear) {
      return submission;
    }
  });

  if (submission.length > 0) {
    return submission[0].id;
  }
  return null;
}



function checkIfResubmission(establishment, filingYear) {
  if (establishment.years_submitted) {
    return establishment.years_submitted.indexOf(filingYear);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EstablishmentPage);



/** WEBPACK FOOTER **
 ** ./src/components/establishment/singleEstablishment/EstablishmentPage.js
 **/